/**
 * SWORD API
 * SWORD service API to be consumed by SWORD Angular SPA. Interfaces with Entra ID and DataBricks.
 *
 * OpenAPI spec version: v1
 * Contact: donnie.hyatt@tnedu.gov
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { StudentActiveEnrollment } from './studentActiveEnrollment';
import { StudentAttendance } from './studentAttendance';
import { StudentClubMembership } from './studentClubMembership';
import { StudentClassAssignment } from './studentClassAssignment';
import { StudentEndOfService } from './studentEndOfService';
import { StudentEnrollmentHistory } from './studentEnrollmentHistory';
import { StudentFinalGrade } from './studentFinalGrade';
import { StudentClassification } from './studentClassification';
import { StudentDisciplinaryAction } from './studentDisciplinaryAction';
import { StudentDemographic } from './studentDemographic';

/**
 * Student data model
 */
export interface Student { 
    assignmentPeriodEndDate?: string;
    assignmentPeriodStartDate?: string;
    /**
     * Attendance
     */
    attendance?: Array<StudentAttendance>;
    /**
     * Class assignments
     */
    classAssignments?: Array<StudentClassAssignment>;
    /**
     * Classifications
     */
    classifications?: Array<StudentClassification>;
    /**
     * Club memberships
     */
    clubMemberships?: Array<StudentClubMembership>;
    /**
     * Current nrollment info
     */
    currentEnrollmentInfo?: Array<StudentActiveEnrollment>;
    /**
     * Date if birth
     */
    dateOfBirth?: string;
    demographics?: StudentDemographic;
    /**
     * Disciplinary actions
     */
    disciplinaryActions?: Array<StudentDisciplinaryAction>;
    /**
     * District number name concatenation
     */
    readonly district?: string;
    districtId?: string;
    /**
     * District name
     */
    districtName?: string;
    districtNumber?: number;
    edFi_Id?: string;
    /**
     * Ends of service
     */
    endsOfService?: Array<StudentEndOfService>;
    enrollmentCode?: string;
    enrollmentEndDate?: string;
    enrollmentStartDate?: string;
    enrollmentHistory?: Array<StudentEnrollmentHistory>;
    /**
     * Final grades
     */
    finalGrades?: Array<StudentFinalGrade>;
    /**
     * Gender
     */
    gender?: string;
    /**
     * Grade
     */
    grade?: string;
    /**
     * First name
     */
    nameFirst?: string;
    /**
     * Last name
     */
    nameLast?: string;
    /**
     * Middle name
     */
    nameMiddle?: string;
    /**
     * School number name concatenation
     */
    readonly school?: string;
    /**
     * School identifier
     */
    schoolId?: string;
    /**
     * School name
     */
    schoolName?: string;
    /**
     * School number
     */
    schoolNumber?: number;
    /**
     * Service district
     */
    serviceDistrict?: string;
    /**
     * Service school
     */
    serviceSchool?: string;
    /**
     * Service type
     */
    serviceType?: string;
    /**
     * SSID
     */
    ssid?: number;
    /**
     * Standard day minutes
     */
    standardDayMinutes?: number;
    stateStudentId?: string;
    /**
     * Student identifier
     */
    studentId?: string;
    /**
     * Withdrawal code
     */
    withdrawalCode?: string;
    /**
     * Withdrawal end date
     */
    withdrawalEndDate?: string;
}
